<template>
    <div class="Intro basic-type position-relative" :class="color">
        <div class="AnimateBgImg" :class="{'animate': animate }">
            <img
                src="../../assets/image/background wave-1.png"
                class="position-absolute top-0 start-0"
            />
        </div>
        
        <div id="IntroTitle" class="container-xl text-center text-primary">
            <TitleUnderline :title="introData.title" :color="color"></TitleUnderline>
        </div>
        <p class="introContent" v-html="introData.content"></p>
    </div>
</template>
<script>
export default {
    props: {
        color: {
            type: String
        },
        introData: {
            type: Object,
            default: {
                title: "",
                content: ""
            }
        }
    },
    data() {
        return {
            animate: false
        }
    },
    created() {
        window.addEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            const IntroTitleHtmlObj = document.getElementById("IntroTitle")
            if(IntroTitleHtmlObj) {
                const rect = IntroTitleHtmlObj.getBoundingClientRect()
                if (Math.abs(rect.top) < 500 && Math.abs(rect.top) > 230) {
                    this.animate = true
                }
            }
        }
    }
}
</script>
<style lang="scss">
.Intro {
    z-index: 0;
    &.green {
        .AnimateBgImg {
            &::after {
                background-color: #F7FBF2;
            }
        }
    }
    .AnimateBgImg {
        position: absolute;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        top: 0;
        left: 0;
        z-index: -1;
        img {
            width: 100%;
            height: auto;
            max-height: 100vh; 
            z-index: -2;
        }
        &::after {
            content: '';
            display: block;
            position: absolute;
            width: 100%;
            height: 100vw;
            background-color: transparent;
            top: 0;
            left: 0;
            z-index: -1;
        }
        &.animate {
            &::after {
                animation: top-to-bottom 2s ease-in forwards;
            }
        }
    }
    .introContent {
        text-align: center;
        line-height: 2;
        font-size: 1.5rem;
        @media (max-width: $md) {
            font-size: 0.875rem;
        }
    }
}

@keyframes top-to-bottom {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(100%);
    }
}
</style>